import React from 'react';
import UserView from './UserView';

const UserViewController = () => {
    return <UserView />
};

export default UserViewController;